import { monotonicFactory } from 'ulidx';
import Cookies from 'universal-cookie';

const ulid = monotonicFactory();

let SOPS = '';
// Site Owner Product Status is saved as a sops cookie like {accountId}#1=A#2=A#3=A#4=A#5=A#6=A#7=N#8=N#9=A#10=O#
// and is translated to the format AAAAAANNAO to be sent with GA tracking data
const getSops = () => {
  if (SOPS !== '') return SOPS;
  const cookies = new Cookies();
  const untranslated = cookies.get('sops');
  SOPS = untranslated
    ? untranslated
        .split('#')
        .map((f: string) => f.split('=')[1])
        .filter((f: string) => !!f)
        .join('')
    : '';
  return SOPS;
};

export { getSops, ulid };
